"use client";

import { useCallback, useState } from "react";
import { useAuth } from "@clerk/nextjs";

const ANON_CONVERSIONS_KEY = "fitconvert-anon-conversions";
const FREE_ANON_CONVERSIONS = 1;

// Anonymous visitors get one free conversion or repair — shared across both
// tools via the same localStorage counter — before being asked to sign up
// for unlimited use.
export function useAnonGate() {
  const [showSignInGate, setShowSignInGate] = useState(false);
  const { isSignedIn } = useAuth();

  const checkAnonGate = useCallback(() => {
    if (isSignedIn === false) {
      const anonCount = Number(localStorage.getItem(ANON_CONVERSIONS_KEY) || "0");
      if (anonCount >= FREE_ANON_CONVERSIONS) {
        setShowSignInGate(true);
        return true;
      }
    }
    return false;
  }, [isSignedIn]);

  const recordAnonConversion = useCallback(() => {
    if (isSignedIn === false) {
      const anonCount = Number(localStorage.getItem(ANON_CONVERSIONS_KEY) || "0") + 1;
      localStorage.setItem(ANON_CONVERSIONS_KEY, String(anonCount));
    }
  }, [isSignedIn]);

  return { showSignInGate, setShowSignInGate, checkAnonGate, recordAnonConversion };
}
